module.exports = __webpack_public_path__ + "img/pay_bank_19.a3327f4d.png";